<template>
  <ValidationObserver ref="form">
    <form novalidate @submit.prevent="submitForm">
      <slot></slot>
    </form>
  </ValidationObserver>
</template>

<script>
export default {
  name: "validation-form",
  props: ["onSubmit"],
  methods: {
    submitForm() {
      this.$refs.form.validate().then(success => {
        if (!success) {
          return;
        }

        this.$emit("on-submit");
      });
    },

    resetForm() {
      this.$refs.form.reset();
    }
  }
};
</script>

<style lang="scss" scoped>
span {
  display: block;
}
</style>
